import invoiceInstance from '../instance'

const updateInvoiceCustomer = (invoiceUuid, data) => {
	return invoiceInstance.put(`/invoices/${invoiceUuid}/customerBillingAddress`, data)
}

export default updateInvoiceCustomer
